import _extends from "@babel/runtime-corejs3/helpers/extends";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/includes";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Map from "@babel/runtime-corejs3/core-js-stable/map";
import { addMonths, addYears } from 'date-fns';
import { DEFAULT_YEAR_ITEM_NUMBER, localeParse } from './date-fns';
export function toArray(val) {
  if (val === null || val === undefined) {
    return [];
  }
  return Array.isArray(val) ? val : [val];
}
export function getValue(values, index) {
  return values ? values[index] : null;
}
export function updateValues(values, value, index) {
  var newValues = [getValue(values, 0), getValue(values, 1)];
  newValues[index] = typeof value === 'function' ? value(newValues[index]) : value;
  if (!newValues[0] && !newValues[1]) {
    return null;
  }
  return newValues;
}
export function getClosingViewDate(viewDate, picker) {
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var yearItemNumber = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : DEFAULT_YEAR_ITEM_NUMBER;
  switch (picker) {
    case 'year':
      return addYears(viewDate, offset * yearItemNumber);
    case 'quarter':
    case 'month':
      return addYears(viewDate, offset);
    default:
      return addMonths(viewDate, offset);
  }
}
// ===================== Format =====================
export function getDefaultFormat(format, picker, showTime, use12Hours) {
  var mergedFormat = format;
  if (!mergedFormat) {
    switch (picker) {
      case 'time':
        mergedFormat = use12Hours ? 'hh:mm:ss a' : 'HH:mm:ss';
        break;
      case 'week':
        mergedFormat = 'gggg-wo';
        break;
      case 'month':
        mergedFormat = 'YYYY-MM';
        break;
      case 'quarter':
        mergedFormat = 'YYYY-QQQ';
        break;
      case 'year':
        mergedFormat = 'YYYY';
        break;
      default:
        if (showTime) {
          if (use12Hours) {
            mergedFormat = 'YYYY-MM-DD hh:mm:ss a';
          } else {
            mergedFormat = 'YYYY-MM-DD HH:mm:ss';
          }
        } else {
          mergedFormat = 'YYYY-MM-DD';
        }
    }
    mergedFormat = localeParse(mergedFormat);
  }
  return mergedFormat;
}
export function getPlaceholder(picker, locale, customizePlaceholder) {
  if (customizePlaceholder !== undefined) {
    return customizePlaceholder;
  }
  if (picker === 'year' && locale.yearPlaceholder) {
    return locale.yearPlaceholder;
  }
  if (picker === 'quarter' && locale.quarterPlaceholder) {
    return locale.quarterPlaceholder;
  }
  if (picker === 'month' && locale.monthPlaceholder) {
    return locale.monthPlaceholder;
  }
  if (picker === 'week' && locale.weekPlaceholder) {
    return locale.weekPlaceholder;
  }
  if (picker === 'time' && locale.timePlaceholder) {
    return locale.timePlaceholder;
  }
  return locale.placeholder;
}
export function getRangePlaceholder(picker, locale, customizePlaceholder) {
  if (customizePlaceholder !== undefined) {
    return customizePlaceholder;
  }
  if (picker === 'year' && locale.rangeYearPlaceholder) {
    return locale.rangeYearPlaceholder;
  }
  if (picker === 'quarter' && locale.rangeQuarterPlaceholder) {
    return locale.rangeQuarterPlaceholder;
  }
  if (picker === 'month' && locale.rangeMonthPlaceholder) {
    return locale.rangeMonthPlaceholder;
  }
  if (picker === 'week' && locale.rangeWeekPlaceholder) {
    return locale.rangeWeekPlaceholder;
  }
  if (picker === 'time' && locale.rangeTimePlaceholder) {
    return locale.rangeTimePlaceholder;
  }
  return locale.rangePlaceholder;
}
export function elementsContains(elements, target) {
  return elements.some(function (ele) {
    return ele && ele.contains(target);
  });
}
export function getInputSize(picker, format) {
  var defaultSize = picker === 'time' ? 8 : 10;
  var length = format.length;
  return Math.max(defaultSize, length) + 2;
}
export function getDataOrAriaProps(props) {
  var retProps = {};
  _Object$keys(props).forEach(function (key) {
    if ((key.substr(0, 5) === 'data-' || key.substr(0, 5) === 'aria-' || key === 'role' || key === 'name') && key.substr(0, 7) !== 'data-__') {
      retProps[key] = props[key];
    }
  });
  return retProps;
}
export function getTimeProps(props) {
  var format = props.format,
    picker = props.picker,
    showHour = props.showHour,
    showMinute = props.showMinute,
    showSecond = props.showSecond,
    use12Hours = props.use12Hours;
  var firstFormat = toArray(format)[0];
  var showTimeObj = _extends({}, props);
  if (firstFormat) {
    if (!_includesInstanceProperty(firstFormat).call(firstFormat, 's') && showSecond === undefined) {
      showTimeObj.showSecond = false;
    }
    if (!_includesInstanceProperty(firstFormat).call(firstFormat, 'm') && showMinute === undefined) {
      showTimeObj.showMinute = false;
    }
    if (!_includesInstanceProperty(firstFormat).call(firstFormat, 'H') && !_includesInstanceProperty(firstFormat).call(firstFormat, 'h') && showHour === undefined) {
      showTimeObj.showHour = false;
    }
    if ((_includesInstanceProperty(firstFormat).call(firstFormat, 'a') || _includesInstanceProperty(firstFormat).call(firstFormat, 'A')) && use12Hours === undefined) {
      showTimeObj.use12Hours = true;
    }
  }
  if (picker === 'time') {
    return showTimeObj;
  }
  return {
    showTime: showTimeObj
  };
}
export function leftPad(str, length) {
  var fill = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0';
  var current = String(str);
  while (current.length < length) {
    var _context;
    current = _concatInstanceProperty(_context = "".concat(fill)).call(_context, str);
  }
  return current;
}
export function isVisible(element) {
  if (!element) {
    return false;
  }
  if (element.offsetParent) {
    return true;
  }
  if (element instanceof SVGGraphicsElement) {
    var box = element.getBBox();
    if (box.width || box.height) {
      return true;
    }
  }
  if (element instanceof HTMLElement) {
    var _box = element.getBoundingClientRect();
    if (_box.width || _box.height) {
      return true;
    }
  }
  return false;
}
var raf = function raf(callback) {
  return +setTimeout(callback, 16);
};
var caf = function caf(num) {
  return clearTimeout(num);
};
if (typeof window !== 'undefined' && 'requestAnimationFrame' in window) {
  raf = function raf(callback) {
    return window.requestAnimationFrame(callback);
  };
  caf = function caf(handle) {
    return window.cancelAnimationFrame(handle);
  };
}
function wrapperRaf(callback) {
  return raf(callback);
}
wrapperRaf.cancel = caf;
export function waitElementReady(element, callback) {
  var id;
  function tryOrNextFrame() {
    if (isVisible(element)) {
      callback();
    } else {
      id = wrapperRaf(function () {
        tryOrNextFrame();
      });
    }
  }
  tryOrNextFrame();
  return function () {
    wrapperRaf.cancel(id);
  };
}
var scrollIds = new _Map();
/* eslint-disable no-param-reassign */
export function scrollTo(element, to, duration) {
  if (scrollIds.get(element)) {
    cancelAnimationFrame(scrollIds.get(element));
  }
  // jump to target if duration zero
  if (duration <= 0) {
    scrollIds.set(element, requestAnimationFrame(function () {
      element.scrollTop = to;
    }));
    return;
  }
  var difference = to - element.scrollTop;
  var perTick = difference / duration * 10;
  scrollIds.set(element, requestAnimationFrame(function () {
    element.scrollTop += perTick;
    if (element.scrollTop !== to) {
      scrollTo(element, to, duration - 10);
    }
  }));
}
var getYearNextMode = function getYearNextMode(next) {
  if (next === 'month' || next === 'date') {
    return 'year';
  }
  return next;
};
var getMonthNextMode = function getMonthNextMode(next) {
  if (next === 'date') {
    return 'month';
  }
  return next;
};
var getQuarterNextMode = function getQuarterNextMode(next) {
  if (next === 'month' || next === 'date') {
    return 'quarter';
  }
  return next;
};
var getWeekNextMode = function getWeekNextMode(next) {
  if (next === 'date') {
    return 'week';
  }
  return next;
};
export var PickerModeMap = {
  year: getYearNextMode,
  month: getMonthNextMode,
  quarter: getQuarterNextMode,
  week: getWeekNextMode,
  time: null,
  date: null
};
export var getInternalNextMode = function getInternalNextMode(nextMode, picker) {
  var getNextMode = PickerModeMap[picker];
  if (getNextMode) {
    return getNextMode(nextMode);
  }
  return nextMode;
};
export var generateUnits = function generateUnits(start, end, step, disabledUnits) {
  var units = [];
  for (var i = start; i <= end; i += step) {
    var _context2;
    units.push({
      label: leftPad(i, 2),
      value: i,
      disabled: _includesInstanceProperty(_context2 = disabledUnits || []).call(_context2, i)
    });
  }
  return units;
};